export const whyTrovaList = [
  {
    pathname: require('../images/chart.svg'),
    header: 'AI-Driven',
    text: 'Trova is driven by the latest AI technology in natural language processing and information retrieval. We utilize deep learning to conduct conversational search and to efficiently deliver results.',
  },
  {
    pathname: require('../images/code-quality.svg'),
    header: 'High Quality of Code',
    text: 'Efficient graph schemas and indexing algorithms provide accuracy, completeness, and scalability for Trova’s constructed search space.',
  },
  {
    pathname: require('../images/patent-tech.svg'),
    header: 'Flexible Keyword Search',
    text: 'Context matters in your search. Trova accurately delivers the information you are looking for even with slightly imprecise keywords, including non-textual messages.',
  },
  {
    pathname: require('../images/cross-platform.svg'),
    header: 'Cross-platform',
    text: 'Trova supports searching across multiple platforms in a unified space and transforms how personal information is organized.',
  },
  {
    pathname: require('../images/automated-testing.png'),
    header: 'Boost Productivity',
    text: 'With the low latency of Trova, you can quickly retrieve and organize the digital conversations scattered in various workspaces to save time.',
  },
  {
    pathname: require('../images/automated-testing.png'),
    header: 'Constant Improvement',
    text: 'Collaborative module of Trova invites users to provide feedback to train the search engine and help improve searching performance.',
  },
];